<template>
  <Carousel v-bind="settings" class="w-auto">
    <Slide v-for="(item, index) in items.banners" :key="index">
      <div
        class="flex flex-col items-center self-start w-36 px-1 cursor-pointer"
        @click="useBannerAction(item, items.header,index)"
      >
        <div class="flex relative overflow-hidden w-full justify-center">
          <NuxtImg
            :src="item.content.source"
            class="size-full h-36 w-36"
            quality="90"
            loading="lazy"
            alt="Banner image"
            title="Promotional banner"
          />
          <div
            v-if="config.footer && item.meta?.footer"
            class="absolute bottom-0 rounded-bl-md rounded-br-md p-1 bg-gray-500 border border-stone-200 border-t-0 w-full"
          >
            <p class="text-sm text-wrap text-white">{{ item.meta?.footer }}</p>
          </div>
        </div>
        <div class="flex flex-col px-1 text-center">
          <h5 class="line-clamp-2 break-words text-sm" v-if="config.title">
            {{ item.meta?.title }}
          </h5>
          <p
            class="text-sm text-wrap text-gray-700 dark:text-gray-200 line-clamp-2 break-all"
            v-if="config.sub_title"
          >
            {{ item.meta?.sub_title }}
          </p>
        </div>
      </div>
    </Slide>
  </Carousel>
</template>

<script setup>
const props = defineProps(["items", "config", "layout", "size"]);
const { isMobile } = useDevice();

const isSquare = props.layout === "square";
const isLarge = props.size && props.size === "max";

const sizeClasses = isSquare
  ? isMobile
    ? isLarge
      ? "h-64 w-full"
      : "h-56 w-full"
    : isLarge
    ? "h-[6.75rem] w-full"
    : "h-[6rem] w-full"
  : isMobile
  ? "h-auto w-full"
  : isLarge
  ? "h-[6rem]"
  : "h-[5.625rem]";
const roundedClasses = isSquare ? "rounded-md" : "rounded-full";
const borderClasses = props.config.border ? "border border-stone-200" : "";
const classes = [
  "object-contain",
  ...sizeClasses,
  ...roundedClasses,
  ...borderClasses,
];

const mobileItems = isLarge ? 2.05 : 2.75;
// const mobileItems = isLarge ? 4.05 : 4.25;
const desktopItems = isLarge ? 8.15 : 8.25;
const squareMobileItems = isLarge ? 3.05 : 3.15;
const squareDesktopItems = isLarge ? 9.05 : 9.15;

const itemsToShow = ref(isMobile ? squareMobileItems : squareDesktopItems);
if (!isSquare) {
  itemsToShow.value = isMobile ? mobileItems : desktopItems;
}

const settings = {
  itemsToShow: itemsToShow.value,
  snapAlign: "start",
};
</script>
